import React from 'react'
import styled from 'styled-components'
import Toggle from '../../toggle/toggle'
import { giphyLightCharcoal } from '@giphy/js-brand'
import { LoggedInUser } from 'shared/types/user'
import { IGif } from '@giphy/js-types'

const Privacy = styled.div`
    float: left;
    vertical-align: top;
`

const ToggleContainer = styled.div`
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
`

const ToggleLabel = styled.span`
    font-size: 10px;
    text-transform: uppercase;
`

const Label = styled.span`
    display: inline-block;
    vertical-align: middle;
`

type Props = {
    permissions: any
    user: LoggedInUser
    gifs: IGif[]
    onTogglePrivacy: Function
}

const PrivacyToggle = ({ permissions, user, gifs, onTogglePrivacy }: Props) => (
    <Privacy>
        <Label>Public</Label>
        {(permissions.hide || user.isStaff) && (
            <ToggleContainer>
                <Toggle
                    isOn={!gifs.some(gif => gif.is_hidden)}
                    onElement={<ToggleLabel>On</ToggleLabel>}
                    offElement={<ToggleLabel>Off</ToggleLabel>}
                    backgroundColor={giphyLightCharcoal}
                    toggle={isOn => onTogglePrivacy(isOn)}
                />
            </ToggleContainer>
        )}
    </Privacy>
)

export default PrivacyToggle
